<template>
  <div class="wrapper bg">
    <div class="banner">
      <img src="https://pic.dailyqd.com/2021/1229/banner.png" style="width: 100%">
    </div>
    <div class="mainbox">
      <!--页面按钮-->
      <div class="btnbox">
<!--        <div class="btn_nor"><a href="https://pic.dailyqd.com/2021/zmt/index.html">评奖提报页</a></div>-->
        <div class="btn_sel">优秀展示页</div>
      </div>
      <h1><img src="../../assets/img/tit2.png"></h1>

      <!-------------------tab切换start------------------->
      <div class="list">
        <!----切换菜单---->
        <ul id="myTab1">
          <li class="normal" v-for="(item,index) in tabsParam"
            @click="toggleTabs(index)"
            :class="{active:index==nowIndex}">{{item}}</li>
        </ul>
        <div class="c"></div>
      </div><!----切换菜单结束---->
      <!--选项卡1-->
      <div id="myTab1_Content0" v-show="nowIndex===0">
        <div class="showbox">
          <h2>优秀自媒体人物展示</h2>
          <div class="itembox" v-for="(item,index) in human">
            <a :href="link+item.id" >
<!--              <el-image :key="item.image" :src="item.image" lazy></el-image>-->
              <img :src="item.image">
            </a>
              <div class="text">
                <p>编号：{{ item.number }}号</p>
                <p>姓名：{{ item.name }}</p>
                <div class="btn1" @click="vote($event,item.id)">能量：{{ item.like }}</div>
              </div>
          </div>
        </div>
      </div>
      <!--选项卡1end-->
      <!--选项卡2-->
      <div id="myTab1_Content1" v-show="nowIndex===1">
        <div class="showbox">
          <h2>优秀自媒体账号展示</h2>
          <div class="itembox" v-for="item in account">
            <a :href="link+item.id" >
              <img :src="item.image">
            </a>
              <div class="text">
                <p>编号：{{ item.number }}号</p>
                <p>帐号名称：{{ item.name }}</p>
                <div class="btn1"  @click="vote($event,item.id)">能量：{{ item.like }}</div>
              </div>
          </div>
        </div>
      </div>
      <!--选项卡2end-->
      <!--选项卡3-->
      <div id="myTab1_Content2" v-show="nowIndex===2">
        <div class="showbox">
          <h2>优秀自媒体作品展示</h2>
          <div class="itembox" v-for="item in work">
            <a :href="link+item.id" >
              <img :src="item.image">
            </a>
              <div class="text">
                <p>编号：{{ item.number }}号</p>
                <p>作品名称：{{ item.name }}</p>
                <div class="btn1"  @click="vote($event,item.id)">能量：{{ item.like }}</div>
              </div>
          </div>
        </div>
      </div>
      <!--选项卡3end-->
      <!--选项卡4-->
      <div id="myTab1_Content4" v-show="nowIndex===3">
        <div class="showbox">
          <h2>优秀传播案例展示</h2>
          <div class="itembox" v-for="item in acase">
            <a :href="link+item.id" >
              <img :src="item.image">
            </a>
              <div class="text">
                <p>编号：{{ item.number }}号</p>
                <p>案例名称：{{ item.title }}</p>
                <div class="btn1"  @click="vote($event,item.id)">能量：{{ item.like }}</div>
              </div>
          </div>

        </div>
      </div>
      <!--选项卡4end-->
      <!-------------------tab切换end------------------->
    </div>
  </div>
</template>

<script>
import '../../assets/style.css';
import { Loading } from 'element-ui';
import axios from 'axios';
let loading;
const startLoading = ()=>{
  loading = Loading.service({
    lock:true,
    text:'加载中...',
    background:'rgba(255,255,255,0.7)',
  })
}
var time = 0;       //初始时间
var t=0;
startLoading();
export default {
  name: 'list',
  data () {
    return {
      tabsParam:['优秀自媒体人物','优秀自媒体账号','优秀自媒体作品','优秀自媒体传播案例'],
      nowIndex:0,
      human:[],
      account:[],
      work:[],
      acase:[],
      link:'https://hd.an.guanhai.com.cn/20211230/starfish/#/articleContent?id='

    }
  },
  created() {
    loading.close();
    this.getData('204');
    setTimeout(()=>{
      this.getData('205');
      this.getData('206');
      this.getData('207');
    },1000)
  },
  mounted() {
    loading.close();
  },
  methods: {
    //tab切换
    toggleTabs(index) {
      this.nowIndex = index;

    },
    //获取数据，n2表示分页当前页 n3搜索的数据默认为‘’
    getData(n1) {
      // 这里使用axios，使用时请提前引入
      axios.get('https://www.dailyqd.com/wemedia/api/starfish/list/'+n1)
        .then(response => {
          if(n1=='204'){
            this.human = response.data.data;
          } else if(n1=='205'){
            this.account = response.data.data;
          }else if(n1=='206'){
            this.work = response.data.data;
          }else if(n1=='207'){
            this.acase = response.data.data;
          }

        })
        .catch(error => {
          this.$notify({
            title: '数据未加载成功，请刷新页面。',
            type: 'error',
          });
        })
    },
    vote(event,id){
      // startLoading();
      if (time == 0) {
        time = (new Date()).valueOf();      //初始时间戳
        axios.post('https://www.dailyqd.com/wemedia/api/starfish/vote/'+id)
          //验证通过,投票
          .then(response=>{
            if(response.data.code==200){
              let num = event.target.innerHTML;
              let numArr = num.match(/\d+/g);
              numArr = parseInt(numArr) + 1;
              event.target.innerHTML = '能量：' + numArr;

              this.$notify({
                title: '能量添加成功',
                type: 'success',
              });
            }else {
              this.$notify({
                title:'能量添加失败',
                type: 'error',
              });
            }
          })
          .catch(error=>{
            loading.close();
            this.$notify({
              title:'您的操作过于频繁，请稍后再试。',
              type: 'error',
            });
          })
      } else {
        var t = Number((new Date()).valueOf()) - Number(time);   //两个时间差值
        if (t <= 300000) {
          this.$notify({
            title: '压力大，5分钟之后再来~',
            type: 'error',
          });
          return;
        } else {
          time = (new Date()).valueOf();    //给time赋值上一次时间戳
          axios.post('https://www.dailyqd.com/wemedia/api/starfish/vote/'+id)
            //验证通过,投票
            .then(response=>{
             // loading.close();
              if(response.data.code==200){
                let num = event.target.innerHTML;
                let numArr = num.match(/\d+/g);

                numArr = parseInt(numArr) + 1;
                event.target.innerHTML = '能量：' + numArr;

                this.$notify({
                  title: '能量添加成功',
                  type: 'success',
                });
              }else {
                this.$notify({
                  title:'能量添加失败',
                  type: 'error',
                });
              }
            })
            .catch(error=>{
              loading.close();
              this.$notify({
                title:'您的操作过于频繁，请稍后再试。',
                type: 'error',
              });
            })
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

　/deep/.el-image {
  display: block;
  min-height: 200px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/list.vue